import React from 'react';
import { Card } from '../components/ui/card';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export default function ContactUs() {
  return (
    <div className="min-h-screen py-12">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h1 className="font-display text-3xl sm:text-4xl text-foreground font-semibold mb-4">Contact Us</h1>
        <p className="text-muted-foreground mb-10">We're here to help. Reach out through any of the channels below.</p>

        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          {[
            { icon: Mail, title: 'Email', detail: 'support@vwatch.shop', sub: 'We respond within 24 hours', href: 'mailto:support@vwatch.shop' },
            { icon: Phone, title: 'WhatsApp', detail: '+971 50 363 4567', sub: 'Available 9 AM – 9 PM GST', href: 'https://wa.me/971503634567' },
            { icon: MapPin, title: 'Office', detail: 'Dubai, United Arab Emirates', sub: 'By appointment only' },
            { icon: Clock, title: 'Business Hours', detail: 'Sun – Thu: 9 AM – 6 PM GST', sub: 'Fri – Sat: 10 AM – 4 PM GST' },
          ].map((item, i) => (
            <Card key={i} className="p-5 border-border bg-card">
              <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <item.icon className="h-4 w-4 text-primary" />
                </div>
                <div>
                  <h3 className="font-medium text-foreground text-sm">{item.title}</h3>
                  {item.href ? (
                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline">{item.detail}</a>
                  ) : (
                    <p className="text-sm text-foreground">{item.detail}</p>
                  )}
                  <p className="text-xs text-muted-foreground mt-0.5">{item.sub}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
